/**
 * Removes invisible layers left by nested Material-UI modals or map overlays
 * that block clicks on the service order form.
 */
export function releaseModalBlockers() {
  window.requestAnimationFrame(() => {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.classList.remove("modal-open");
    if (document.body.getAttribute("aria-hidden") === "true") {
      document.body.removeAttribute("aria-hidden");
    }

    document.querySelectorAll(".service-order-map-overlay").forEach((node) => {
      node.remove();
    });

    const openModals = document.querySelectorAll(".MuiModal-root");
    const backdrops = document.querySelectorAll(".MuiBackdrop-root");
    if (backdrops.length > openModals.length) {
      backdrops.forEach((node, index) => {
        if (index >= openModals.length) {
          node.remove();
        }
      });
    }
  });
}

/** @deprecated use releaseModalBlockers */
export const releaseNestedModalSideEffects = releaseModalBlockers;

export const nestedMuiModalProps = {
  hideBackdrop: true,
  disableScrollLock: true,
  disableEnforceFocus: true,
  disableAutoFocus: true,
  disableRestoreFocus: true,
};
